import {
  PublicClientApplication,
  LogLevel,
  type Configuration,
} from '@azure/msal-browser';

export const createMsalConfig = ({
  clientId,
  tenantId,
  redirectUri = globalThis.location.origin,
}: {
  clientId: string;
  tenantId: string;
  redirectUri?: string;
}) => {
  const config: Configuration = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri,
      postLogoutRedirectUri: redirectUri,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowRedirectInIframe: true,
      navigateFrameWait: 0,
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Info:
              console.info(message);
              break;
            case LogLevel.Verbose:
              console.debug(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
          }
        },
        logLevel: LogLevel.Info,
      },
    },
  };

  return new PublicClientApplication(config);
};
